export default [
    {
        path: 'relatorio-cuidado-pessoa-hipertensao',
        component: () => import(
            /* webpackChunkName: 'atencao-basica-relatorio-cuidado-pessoa-hipertensao' */
            '@/views/atencao-basica/relatorio-cuidado-pessoa-hipertensao/Index'
        ),
        redirect: 'relatorio-cuidado-pessoa-hipertensao/index',
        children: [
            {
                name: 'atencao-basica-relatorio-cuidado-pessoa-hipertensao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'atencao-basica-relatorio-cuidado-pessoa-hipertensao' */
                    '@/views/atencao-basica/relatorio-cuidado-pessoa-hipertensao/List.vue'
                ),
            },
        ],
    },
]